import '@material/web/icon/icon.js'
import '@operato/input/ox-input-code.js'

import { css, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { i18next } from '@operato/i18n'
import { closePopup } from '@operato/popup'
import { CommonHeaderStyles, ScrollbarStyles } from '@operato/styles'

@customElement('ox-popup-code-input')
export class OxPopupCodeInput extends LitElement {
  static styles = [
    CommonHeaderStyles,
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);

        width: var(--overlay-center-normal-width, 50%);
        height: var(--overlay-center-normal-height, 50%);
      }

      ox-input-code {
        flex: 1;
        overflow-y: auto;
        margin: var(--spacing-small);
      }
    `
  ]

  @property({ type: Object }) value: any
  @property({ type: String }) mode: string = 'javascript'
  @property({ type: Object }) confirmCallback!: (newval: any) => void
  @property({ type: String }) language?: string = 'javascript'

  render() {
    return html`
      <ox-input-code .value=${this.value} @change=${this.onChange.bind(this)} .language=${this.language}>
      </ox-input-code>

      <div class="footer">
        <div filler></div>
        <button @click=${this.onCancel.bind(this)} danger>
          <md-icon>cancel</md-icon>${i18next.t('button.cancel')}
        </button>
        <button @click=${this.onConfirm.bind(this)} done><md-icon>done</md-icon>${i18next.t('button.confirm')}</button>
      </div>
    `
  }

  private onChange(e: CustomEvent) {
    e.stopPropagation()

    this.value = e.detail
  }

  private onCancel(e: Event) {
    closePopup(this)
  }

  private onConfirm(e: Event) {
    this.confirmCallback && this.confirmCallback(this.value)
    closePopup(this)
  }
}
